import useFeature from '../useFeature';

const useIsGameCurrencyChangeEnabled = () => {
  const isGameCurrencyChangeEnabled = useFeature('isGameCurrencyChangeEnabled');
  return isGameCurrencyChangeEnabled;
};

export default useIsGameCurrencyChangeEnabled;
